<!-- 
	@component
	Simple text-only select component built on the `<Select>` primitive component.

	Usage:
	```svelte
	<TextSelect 
		bind:selectedId={selectedOptionA} 
		options={['sponge', 'star']}
	/>

	<TextSelect 
		bind:selectedId={selectedOptionB}
		options={{sponge: 'SPONGEBOB', star: 'PATRICK'}}
	/>
	```
 -->
<script lang="ts">
	import MultiTextSelect from './TextMultiSelect.svelte';
	import type { TextSelectOptions } from './select';

	export let selectedId: string | undefined = undefined;
	export let options: string[] | TextSelectOptions;
	export let isOpen = false;
	export let prompt = 'Select an option';
	export let displayLabel = 'Sorted by';

	let selectedIds: string[] = selectedId ? [selectedId] : [];

	/* Mandatory but not multiple select so one id will always be selected after first selection change */
	$: selectedId = selectedIds[0];
</script>

<MultiTextSelect
	mandatory
	multiple={false}
	{options}
	{displayLabel}
	bind:selectedIds
	bind:isOpen
	on:selected
	{prompt}
/>
